import React from 'react';
import PropTypes from 'prop-types';

import styles from './troy.module.scss';

import TroyLogo from '../../common/Logo/Logo.troy';
import logo from '../../../assets/img/logos/troy/troy_weiss.png';
import HeaderWithContacts from '.';

const Logo = () => (
  <TroyLogo src={logo} className={styles['header-with-contacts__logo']} />
);

const TroyHeaderWithContacts = React.forwardRef(
  (
    {
      onLogoClick,
      value,
      onTabChange,
      tabs,
      mobileTabs,
      isSticky,
      currentRoute,
    },
    ref
  ) => (
    <HeaderWithContacts
      {...{
        styles,
        onLogoClick,
        Logo,
        value,
        onTabChange,
        tabs,
        mobileTabs,
        ref,
        isSticky,
        currentRoute,
      }}
    />
  )
);

TroyHeaderWithContacts.propTypes = {
  onLogoClick: PropTypes.func,
  hideHeader: PropTypes.bool,
  value: PropTypes.any,
  onTabChange: PropTypes.func,
  tabs: PropTypes.array,
  mobileTabs: PropTypes.array,
  contacts: PropTypes.array,
};

export default TroyHeaderWithContacts;
